import React, { useEffect, useState } from "react";
import { Form, Checkbox, Input, Button } from "semantic-ui-react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useAuth } from "../../../hooks";
import { useLanguage } from "../../../contexts";
import { User } from "../../../api";
import "./NotificationSettingsForm.scss";

const userController = new User();

export function NotificationSettingsForm(props) {
  const { close } = props;
  const { user, accessToken } = useAuth();
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;

  const [enabled, setEnabled] = useState(true);
  const [everyNDays, setEveryNDays] = useState(7);
  const [emailChannel, setEmailChannel] = useState(true);
  const [inAppChannel, setInAppChannel] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const settings = user?.notificationSettings;
    if (!settings) return;
    setEnabled(settings.enabled !== false);
    setEveryNDays(settings.everyNDays || 7);
    setEmailChannel(settings.channels?.email !== false);
    setInAppChannel(settings.channels?.inApp !== false);
  }, [user]);

  const handleSave = async () => {
    setSaving(true);
    try {
      await userController.updateNotificationSettings(accessToken, {
        enabled,
        everyNDays,
        channels: { email: emailChannel, inApp: inAppChannel },
      });
      toast.success(t("notification_settings_saved"));
    } catch (error) {
      toast.error(error?.msg || t("notification_settings_save_error"));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="notification-settings-form">
      <div className="notification-settings-form__header">
        <p className="notification-settings-form__title">{t("notification_settings")}</p>
        <p className="notification-settings-form__subtitle">{t("notification_settings_subtitle")}</p>
      </div>
      <Form>
        <Form.Field>
          <Checkbox
            toggle
            label={t("enable_reminders")}
            checked={enabled}
            onChange={(e, { checked }) => setEnabled(checked)}
          />
        </Form.Field>
        <Form.Field className="notification-settings-form__days-field">
          <div className="notification-settings-form__days-row">
            <label>{t("notify_every_n_days")}</label>
            <Input
              type="number"
              min={1}
              value={everyNDays}
              disabled={!enabled}
              onChange={(e) => setEveryNDays(Math.max(1, parseInt(e.target.value, 10) || 1))}
            />
          </div>
        </Form.Field>

        <div className="notification-settings-form__divider" />

        <label className="notification-settings-form__channels-label">{t("notification_channels")}</label>
        <Form.Field>
          <Checkbox
            label={t("notification_channel_email")}
            checked={emailChannel}
            disabled={!enabled}
            onChange={(e, { checked }) => setEmailChannel(checked)}
          />
        </Form.Field>
        <Form.Field>
          <Checkbox
            label={t("notification_channel_in_app")}
            checked={inAppChannel}
            disabled={!enabled}
            onChange={(e, { checked }) => setInAppChannel(checked)}
          />
        </Form.Field>

        <div className="notification-settings-form__actions">
          <Button type="button" primary loading={saving} disabled={saving} onClick={handleSave}>
            {t("save")}
          </Button>
          <Button type="button" secondary onClick={close}>
            {t("cancel")}
          </Button>
        </div>
      </Form>
      <ToastContainer />
    </div>
  );
}
